module.exports = __webpack_public_path__ + "img/w5.be8d61fa.png";